// A critically damped spring driven by animation frames (ReaderCanvasController.SpringAnimator).
export class Spring {
  private raf = 0;
  private last = 0;
  constructor(private p: number, private target: number, private v: number, private stiffness: number,
    private onStep: (p: number) => void, private done: () => void) {}
  start() {
    this.last = performance.now();
    const tick = (now: number) => {
      const dt = Math.min(1 / 30, (now - this.last) / 1000);
      this.last = now;
      const damping = 2 * Math.sqrt(this.stiffness);
      this.v += (this.stiffness * (this.target - this.p) - damping * this.v) * dt;
      this.p += this.v * dt;
      if (Math.abs(this.target - this.p) < 0.003 && Math.abs(this.v) < 0.05) this.p = this.target;
      this.onStep(this.p);
      if (this.p === this.target) { this.raf = 0; this.done(); return; }
      this.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  }
  stop() { cancelAnimationFrame(this.raf); }
}

export const smoothstep = (a: number, b: number, x: number) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
